
const MailTemplatesIcon = ({ color = "var(--primary-color)", width, height, ...props}) => (
    <svg    
        viewBox="0 0 20 20"
        width={width || 20}
        height={height || 20}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        {...props}
    >
        <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeOpacity={0.72}
            strokeWidth={1.5}
            d="M7.249 8.406 9.687 9.91c.805.496 1.821.496 2.626 0l2.439-1.504"
        />
        <rect
            width={15.006}
            height={11.671}
            x={3.497}
            y={4.446}
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeOpacity={0.72}
            strokeWidth={1.5}
            rx={3}
        />
    </svg>    
)

export default MailTemplatesIcon
